import { useCustomAttributesReady, usePresetViewsReady } from 'bringg-web/hooks';

export const useFilterBarManagerInitialData = () => {
	const { isCustomAttributesEnabled, isCustomAttributesFetched } = useCustomAttributesReady();
	const { isPresetViewsEnabled, isPresetViewsFetched } = usePresetViewsReady();

	const isNotReady =
		(isCustomAttributesEnabled && !isCustomAttributesFetched) || (isPresetViewsEnabled && !isPresetViewsFetched);

	return {
		initialDataReady: !isNotReady,
		isPresetViewsEnabled,
		isCustomAttributesEnabled
	};
};
